import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader-mod/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "left",
  "use": "left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"left\"><defs><style type=\"text/css\"></style></defs><path d=\"M231.587 512.173l48.763 48.793 0.209-0.20599999L743.649 1023.888l48.764-48.762L329.31600001 512 792.413 48.87l-48.763-48.757-463.091 463.12399999-0.209-0.20599999-48.763 48.798 0.173 0.172-0.173 0.172z m0 0\" p-id=\"614\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol